import clsx from "clsx";
import type { PropsWithChildren } from "react";

interface CardProps {
  className?: string;
}

export const Card = ({ children, className }: PropsWithChildren<CardProps>) => {
  const hasCustomBackground =
    typeof className === "string" &&
    /\b!?bg-\S+|\bfrom-\S+|\bvia-\S+|\bto-\S+/.test(className);

  return (
    <article
      className={clsx(
        "rounded-2xl border border-app p-4 shadow-[0_10px_30px_-20px_rgba(13,16,31,0.6)]",
        !hasCustomBackground && "bg-app-surface",
        className
      )}
    >
      {children}
    </article>
  );
};
